import ImageBlot from './ImageBlot';

class CellImageBlot extends ImageBlot {
  static ALLOWED_ATTRIBUTES = [];
  static ALLOWED_PROPERTIES = [];
}

export default CellImageBlot;
